/* eslint-disable react-native/no-color-literals */
import React, { useEffect } from 'react';
import {
  Text,
  Platform,
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  Pressable,
} from 'react-native';
import Image from '@web/components/common/Image';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import ItemCombination from './ItemCombination';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { isWeb } from '~global/screens';

const iconHead = require('~assets/img/my-reviews/icon-choose-combination.png');
const ChooseCombination = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigation = props?.navigation ? props.navigation : useNavigation();
  const { $get, defaultProductImage } = global;
  const selectedProduct = useSelector(
    (state) => state.createReview.selectedProduct,
  );
  const imageProduct = $get(selectedProduct, 'images[0].url', null)
    ? { uri: selectedProduct.images[0].url }
    : defaultProductImage;
  const productName = $get(selectedProduct, 'name', '');
  const brandName = $get(selectedProduct, 'brand.name', '');

  const changeProductHandler = () => {
    dispatch({
      type: 'createReview/setState',
      name: 'section',
      value: 'select_product',
    });
  };

  useEffect(() => {
    if (
      selectedProduct &&
      Array.isArray(selectedProduct.combinations) &&
      selectedProduct.combinations.length < 2 &&
      !isWeb
    ) {
      dispatch({
        type: 'createReview/setState',
        name: 'selectedIndexCombination',
        value: 0,
      });
      dispatch({
        type: 'createReview/setState',
        name: 'section',
        value: 'give_rating',
      });
    }
  }, []);

  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
  };

  return (
    <ScrollView>
      <View style={styles.chooseCombinationContainer}>
        <View style={styles.head}>
          <Image source={iconHead} style={styles.iconHead} />

          <View style={styles.headerTitleWrapper}>
            <Text style={styles.headHeading}>
              Pilih varian dari produk yang akan kamu review
            </Text>
            {isWeb && (
              <Pressable style={styles.modalProductClose} onPress={closeModal}>
                <WithLocalSvg
                  width={13}
                  height={13}
                  asset={require('~assets/img/product/icon-close.svg')}
                />
              </Pressable>
            )}
          </View>

          <View style={styles.displayProductContainer}>
            <View style={styles.displayProduct}>
              <View style={styles.displayProductImageContainer}>
                <Image source={imageProduct} style={styles.imageProduct} />
              </View>
              <View style={styles.displayProductContent}>
                <Text
                  style={styles.displayProductBrandName}
                  numberOfLines={1}
                  ellipsizeMode="tail">
                  {brandName}
                </Text>
                <Text
                  style={styles.displayProductName}
                  numberOfLines={1}
                  ellipsizeMode="tail">
                  {productName}
                </Text>
                <TouchableOpacity onPress={changeProductHandler}>
                  <Text style={styles.displayProductLink}>Change Product</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.body}>
          <View style={styles.combinationContainer}>
            {selectedProduct.list_combinations.map(
              (combinationGroup, index) => (
                <ItemCombination
                  combinationGroup={combinationGroup}
                  index={index}
                  key={`combinationGroup${index}`}
                  navigation={navigation}
                />
              ),
            )}
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingTop: 64,
    flexGrow: 1,
    zIndex: -1,
  },
  iconHead: {
    width: 66,
    height: 81,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  head: {
    backgroundColor: '#BD98D5',
    height: isWeb ? 123 : 144,
    padding: 20,
    paddingHorizontal: 16,
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    position: 'relative',
    ...Platform.select({
      ios: {
        shadowColor: '#D4BAEC',
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.53,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
    }),
  },
  headHeading: {
    fontFamily: 'satoshi-bold',
    fontSize: 17,
    lineHeight: 21,
    color: '#FFFFFF',
    ...(!isWeb && {
      width: 198,
    }),
  },
  imageProduct: {
    height: 50,
    width: 50,
  },
  displayProduct: {
    flexDirection: 'row',
    padding: 12,
    height: 82,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.16,
        shadowRadius: 4,
      },
      android: {
        elevation: 2,
      },
    }),
    ...(isWeb && { boxShadow: '2px 5px 5px 0 rgba(0,0,0,.1)' }),
  },
  displayProductContainer: {
    position: 'absolute',
    left: 16,
    right: 16,
    bottom: -41,
    zIndex: 100,
  },
  displayProductBrandName: {
    fontFamily: 'satoshi-black',
    fontSize: 11,
    lineHeight: 14,
    letterSpacing: 1,
    color: '#404040',
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  displayProductContent: {
    flexShrink: 1,
  },
  displayProductImageContainer: {
    marginRight: 12,
  },
  displayProductName: {
    fontFamily: 'satoshi-medium',
    fontSize: 13,
    lineHeight: 16,
    color: '#6f6f6f',
    marginBottom: 7,
  },
  displayProductLink: {
    fontFamily: 'satoshi-bold',
    fontSize: 11,
    lineHeight: 14,
    color: '#A775C8',
    textDecorationLine: 'underline',
  },
  chooseCombinationContainer: {
    flexGrow: 1,
  },
  headerTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  modalProductClose: {
    position: 'absolute',
    right: 7,
    width: 22,
    height: 22,
    alignItems: 'center',
    justifyContent: 'center',
    ...(isWeb && { cursor: 'pointer' }),
  },
});

export default ChooseCombination;
